import axios from "axios";

axios.interceptors.response.use(
  (response) => response,
  (error) => {

    if (error?.response?.status === 429) {
      console.warn("🚫 Rate limit detected");
      window.dispatchEvent(new Event("rate-limit"));
    }

    return Promise.reject(error);
  }
);